<template>
  <div class="section">
    <div class="container how-it-works">

        <div class="spacer" style="height:30px"></div>
        <h1 >
        <span class='title' :class="'is-size-2 is-size-3-mobile'" style="margin-bottom:0">About BikeSleepBike</span>
      </h1>
       <div class="spacer" style="height:30px"></div>
        <p>{{productName}} is a growing directory of bike touring and bikepacking trip journals written by cyclists on their personal blogs. These small websites often don't show up on Google, but BikeSleepBike makes them easy to find.
            Because each entry is tagged and organized by place, riding style, and more, it's 
            easy to find whatever type of inspiration or planning info you might be looking for.</p>
        <!-- <h1 class="title is-2 ">How BikeSleepBike Works</h1> -->

        <div class="spacer" style="height:80px"></div>
        <Heading 
           
            :heading = "'Common Questions'"
            :smaller="true"
           
        />
        <div class="qa container">
           
            <div class="question">What would I use this for?
            </div>
            <div class="answer">Use {{productName}} to research your next trip, find inspiration and route ideas, and read fun adventure stories. 
            </div>

            <div class="question">Is this like CrazyGuyOnABike.com?
            </div>
            <div class="answer">Sort of but not really. While the overall goal - helping people find bike travel journals - is the same, the method is different. CGOAB is a platform for writing and publishing journals. 
                {{productName}} doesn't host any journals, we just link to those that have already been written on independent blogs and websites. We can coexist peacefully with CGOAB (and Cycle Blaze), all contributing in different ways to the universe
                of bike travel content.
            </div>

            <div class="question">Isn't that what Google is for?
            </div>
            <div class="answer">As a web developer and blogger myself, I'm sorry to inform you that the internet is kind of broken. In order to appear near the top of search results, website owners need to 
                spend time and often money to optimize their site and attract links to it. Most bike travel bloggers are, frankly, horrible at this - we're too busy riding our bikes! Thus, our writing often lies hidden in the deep depths
                of the internet unless someone happens across it and shares it on social media. The goal of {{productName}} is to surface these hidden gems.
            </div>

            <div class="question">Can I add my own journals?
            </div>
            <div class="answer">Yes please! I would LOVE for you to submit your own journals to {{productName}}. All submissions are reviewed and manually approved to keep them relevant, but as long 
                as it's a post about bike travel written from personal experience, it'll most likely be approved. 
            </div>

            <div class="question">Can I add someone else's journals?
            </div>
            <div class="answer">Absolutely! Add your favorite bike bloggers so others can find them too. Public websites are generally fair game to link to (this is how the internet works), but we ask that you use your best judgment. If it seems like the author intends their journals
                mainly for friends and family, don't submit their site without checking with them first.
            </div>

            <div class="question">Can I add links to a commercial site?
            </div>
            <div class="answer">Yes, even if you have ads, affiliate links, or sell products on your site, you may still submit it. We all have to pay the bills somehow! However, in all cases the journal must still 
                be a first-hand account of a specific bicycle trip. No gear reviews, tour company advertisements, or sponsored posts.  
            </div>

            <div class="question">Can I add links to YouTube videos or Facebook pages?
            </div>
            <div class="answer">YouTube video links are now supported (yay!) and I'm considering Facebook pages for the future.
            </div>

            <div class="question">Why haven't my journal submissions been approved yet?
            </div>
            <div class="answer">Possibly because I am hiking or biking in the wilderness for a few weeks and haven't been able to approve them yet. Rest assured
                I will get to them as soon as I'm able. 
            </div>

            <div class="question">How do I know if a journal has already been added?
            </div>
            <div class="answer">Don't worry about adding duplicates. If a post is already on {{productName}}, we'll let you know when you enter the URL.
            </div>

            <div class="question">Can I add old journals or only new ones?
            </div>
            <div class="answer">Both please! Go back and submit your older journals and also submit new ones going forward. 
            </div>

            <div class="question">Can I just submit my home page or category archive? It's annoying to submit each post separately.
            </div>
            <div class="answer">I know. But here's the thing: the value of {{productName}} is in the data we collect about each individual post. When you take the time to submit each post separately and tag them by country (and optionally
                riding style, surface, etc), it creates a rich resource for readers seeking journals about a specific place or riding style. Without this, it's just a list of websites. We're trying to surface buried treasure here...
                So yes, it takes a little time.
            </div>

            <div class="question">But I have hundreds of posts!
            </div>
            <div class="answer">Ok, there is one exception. If you write a separate post for every day, and thus you have potentially dozens of posts for each country, you may submit an index or category page for each country, or
                just the first post for each country. You could also submit a handful of your favorite posts for each country, but I ask that you please keep this number to less than 5 posts per country, or up to 10 for large countries
                that are tagged by subregion (United States and China for example). This compromise helps people find your website based on their location interests without making the BSB archives too unwieldy. 
            </div>

            <div class="question">What's the deal with "rider tags"?
            </div>
            <div class="answer">This is an effort to celebrate diversity in the bicycle travel world. Like it or not, the world is a different place for all of us based on who we are. As a woman who cycles alone, for example, I appreciate reading journals 
                from other solo ladies so I can learn what that experience might be like in various places around the world. 
                The rider tags list can be added to by anyone, so please sumbmit new tags and let's celebrate the many different identities in our bike travel community. 
            </div>

            <div class="question">I didn't give permission for my post to be linked on this site and I want it removed.
            </div>
            <div class="answer">Apologies! The vast majority of bloggers love it when others link to their public website, but I will remove any links that a site owner does not want. <a style="text-decoration:underline" href="/contact">Contact me</a> and I'll remove the link(s) right away.
            </div>

            <div class="question">I have a great idea for something you should do on this site!
            </div>
            <div class="answer">Wonderful! {{productName}} is in its early stages and I rely on feedback like this to grow it into what the community wants it to be. Please use the <a style="text-decoration:underline" href="/contact">contact form</a> to send me a message. I read everything. Thanks!
            </div>

            <div class="question">Who are you?
            </div>
            <div class="answer">I'm Alissa. I love bike travel and bikepacking, and I happen to also like building web apps, which apparently makes me 
                the right person to start this project. If you'd like to know more about me and my own bike adventures, you can visit my other site, <a href="https://exploringwild.com" target="_blank">Exploring Wild</a>.
            
            </div>

        </div>
    </div>

    <div class="section">
        <div class="container">
            <h3 class="title is-size-4">Attributions</h3>
            <p>Europe thumnbnail: Mikkel Houmøller, CC BY-SA 4.0. <a href="https://creativecommons.org/licenses/by-sa/4.0">Source</a>, via Wikimedia Commons</p>
        </div>
    </div>

  </div>
</template>

<script>
import Heading from '@/components/Heading';
export default {
  name: 'HowItWorks',
  components: {Heading},
  data () {
    return {
        productName: "BikeSleepBike"
    }
  },
  metaInfo() {
        return {
            title: 'What is BikeSleepBike?',
            description: "Answers to common questions about this unique project. BikeSleepBike is a well-organized directory of bike touring and bikepacking blogs written by and for the bike travel community. "
            
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .qa {
        text-align:left;
        padding:20px;
    }
    .qa .question {
        font-weight: bold;
        margin-bottom:3px;
        font-size:1.2em;
    }
    .qa .answer {
        margin-bottom:40px;
    }
    .how-it-works {
        background-color:white;
        padding:30px 80px;
    }
    @media screen and (max-width: 768px) {
        .how-it-works {
            padding: 20px 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/HowItWorks.vue